import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, money } from "../../lib/api";

export const OrdersTable = () => {
  const [orders, setOrders] = useState([]);
  useEffect(() => {
    api.adminOrders().then(setOrders).catch((e) => toast.error(errMsg(e)));
  }, []);
  const paid = orders.filter((o) => o.payment_status === "paid");

  return (
    <div data-testid="admin-orders">
      <p className="text-sm text-slate-400 mb-5" data-testid="admin-orders-revenue">
        {paid.length} paid orders · <span className="text-lime">{money(paid.reduce((s, o) => s + o.amount, 0))}</span> total
      </p>
      <div className="space-y-3">
        {orders.length === 0 && <p className="text-slate-500 text-sm">No orders yet.</p>}
        {orders.map((o) => (
          <div key={o.session_id} className="card-surface rounded-xl p-4" data-testid={`admin-order-${o.session_id}`}>
            <div className="flex flex-wrap justify-between gap-2 text-sm">
              <span className="text-slate-300">{o.email}</span>
              <span className="text-slate-500">{new Date(o.created_at).toLocaleString()}</span>
              <span className={o.payment_status === "paid" ? "text-lime" : "text-slate-500"}>{o.payment_status}</span>
              <span className="font-mono-ui">{money(o.amount)}</span>
            </div>
            <p className="text-xs text-slate-400 mt-2">{o.items.map((i) => `${i.quantity} × ${i.name}`).join(" · ")}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
